import { render, staticRenderFns } from "./youhui.vue?vue&type=template&id=3c24724b&scoped=true"
import script from "./youhui.vue?vue&type=script&lang=js"
export * from "./youhui.vue?vue&type=script&lang=js"
import style0 from "./youhui.vue?vue&type=style&index=0&id=3c24724b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c24724b",
  null
  
)

export default component.exports